<script setup>
import { MultipleLookupConfig } from '@pfsc/core/models/multiple-lookup-config';
import { ClassCategory, ORDER_CLASS_CATEGORIES } from '@pfsc/core/models/class-category';
import { globalTranslate } from '@pfsc/shared/locale/app.i18n';
import MultipleLookup from './multiple-lookup.vue';

defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['update:model-value']);

const config = new MultipleLookupConfig({
  title: globalTranslate('lookup.packageType'),
  clearable: true,
  fetch: () => ORDER_CLASS_CATEGORIES,
  toReadable: ClassCategory.toReadable,
});

</script>
<template>
  <multiple-lookup
    :model-value="modelValue"
    :config="config"
    :disabled="disabled"
    @update:model-value="emits('update:model-value', $event)"
  />
</template>
